module.exports = __webpack_public_path__ + "assets/img/triple_close.ba73ed7f.svg";